import { render, staticRenderFns } from "./xcxindex.vue?vue&type=template&id=7ea2c4c2&scoped=true&"
import script from "./xcxindex.vue?vue&type=script&lang=js&"
export * from "./xcxindex.vue?vue&type=script&lang=js&"
import style0 from "./xcxindex.vue?vue&type=style&index=0&id=7ea2c4c2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2c4c2",
  null
  
)

component.options.__file = "xcxindex.vue"
export default component.exports